import vueCanvasNest from './vueCanvasNest.vue'

export default vueCanvasNest



// WEBPACK FOOTER //
// ./src/index.js